import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useAddtoCart from "../../../../../Redux/use-addtocart.js";
const ComboCards = ({ products }) => {
  let color = "blue";
  const { addItem, removeItem } = useAddtoCart();

  const language = useSelector((state) => state?.user?.info?.language);

  const { t } = useTranslation();
  // ---------------------MAIN JSX---------------------------
  return products.map((product) => {
    const {
      COSTRATE,
      PRODUCTSIZE,
      PURRATE,
      brands,
      imageURL,
      mainCat,
      mrp,
      newProductCategory,
      newProductName,
      newProductName_hin,
      pID,
      sp,
      subCat,
    } = product;

    return (
      <div key={pID} className={`card card-${color}`}>
        <div className="card-body d-flex justify-content-between">
          <div>
            {language ? (
              <>
                {language === "en" ? (
                  <h3>{newProductName}</h3>
                ) : (
                  <h3>{newProductName_hin}</h3>
                )}
              </>
            ) : (
              <h3>{newProductName}</h3>
            )}

            {/* <ul>
              {products.split(",").map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul> */}
          </div>
          <div className="d-flex align-items-end">
            <img
              src={imageURL}
              alt="product"
              loading="lazy"
              style={{ maxWidth: "97px", maxHeight: "88px" }}
            />
          </div>
        </div>
        <div className="card-footer d-flex align-items-center justify-content-between">
          <div>
            <h5>
              <strong>₹{sp}</strong>
              {mrp !== sp && <del>₹{mrp}</del>}
            </h5>
          </div>
          <a
            href="#"
            className="add-cart-link"
            // data-bs-target={`#comboBottomCart${pID}`}
            // data-bs-toggle="offcanvas"
            onClick={(e) => {
              e.preventDefault();

              addItem(product);
              // BottomSheetHandler(pID);
            }}
          >
            {t("Add")}
          </a>
        </div>
        {/* <BottomSheet
          comboId={pID}
          ComboProduct={ComboProduct}
          comboName={comboName}
          comboTotalSP={comboTotalSP}
          comboTotalMRP={comboTotalMRP}
        /> */}
        <div style={{ display: "none", visibility: "collapse" }}>
          {color === "blue"
            ? (color = "red")
            : color === "red"
            ? (color = "green")
            : (color = "blue")}
        </div>
      </div>
    );
  });
};
export default ComboCards;
